import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import aboutus1 from '../../../assets/img/about/home-about-us-1.jpeg';
import aboutus2 from '../../../assets/img/about/home-about-us-2.jpeg';

class Aboutus extends Component {
    render() {
        return (
            <div className="section pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 acr-single-img-wrapper mb-lg-30">
                            <div className="section-title-wrap section-header acr-dots-wrapper">
                                <h2 className="title">Dare to dream</h2>
                                <div className="acr-dots" />
                            </div>
                            <img src={aboutus2} alt="listing" />
                        </div>
                        <div className="col-lg-6 acr-single-img-wrapper">
                            <div className="section-title-wrap">
                                <img src={aboutus1} alt="listing" />
                                <p className="subtitle">We are pleased to share with you all the details and insights of these magnificent properties in Malta. Unique architecture, breathtaking vistas, impressive living spaces, accompanied by all the latest technology that comes with a stylish lifestyle at its finest. Enjoy exploring the magic world of the best Malta Real Estate!</p>
                                <Link to="/listings" className="btn-link custom-primary">Browse Listings <i className="fas fa-arrow-right" /> </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Aboutus;